/**
 * wagbappro.id Blog 印尼语内容（文案 1:1 还原需求文档）
 */
const img = (name) => require(`@/assets/wagbappro/${name}`);

/** 真实内容图（content/ 目录） */
export const blogImages = {
  login: img('content/15-blog-login.webp'),
  sendMessage: img('content/16-blog-send-message.webp'),
  installError: img('content/17-blog-install-error.webp'),
};

export const blogPosts = [
  {
    slug: 'install-error',
    path: '/wa-gb-gagal-instal-apk/',
    cardTitle: 'WA GB Gagal Instal APK',
    listTitle: 'Cara Mengatasi WA GB Gagal Instal / APK Tidak Bisa Dipasang di Android',
    description:
      'Panduan mengatasi WA GB gagal instal, error APK, dan masalah pemasangan di Android. Solusi lengkap untuk memperbaiki install error dengan cepat.',
    date: '6 Jul 2026',
    image: blogImages.installError,
    imageAlt: 'Cara Mengatasi WA GB Gagal Instal APK',
    sections: [
      {
        title: 'Cara Mengatasi WA GB Gagal Instal / Kenapa APK Tidak Bisa Dipasang?',
        paragraphs: [
          'Jika WA GB gagal dipasang, biasanya masalahnya ada pada file APK yang rusak, pengaturan keamanan Android, atau versi sistem yang tidak kompatibel. Solusi tercepat adalah mengaktifkan izin instalasi, mengunduh ulang APK, dan memastikan ruang penyimpanan cukup.',
        ],
      },
      {
        title: 'Kenapa APK WA GB Tidak Bisa Dipasang?',
        conclusion: 'Android memblokir instalasi karena keamanan atau file tidak cocok.',
        paragraphsAfter: [
          'Android memiliki sistem keamanan yang otomatis menolak aplikasi dari luar Play Store jika tidak diizinkan.',
        ],
      },
      {
        title: 'Kenapa Muncul “App Not Installed”?',
        conclusion: 'file APK biasanya rusak atau tidak lengkap.',
        paragraphsAfter: ['Ini sering terjadi jika file download tidak sempurna.'],
      },
      {
        title: 'Kenapa Instal Berhasil Tapi Aplikasi Tidak Bisa Dibuka?',
        conclusion: 'konflik versi lama dan baru.',
        paragraphsAfter: ['Sistem mendeteksi dua versi berbeda di perangkat.'],
      },
      {
        title: 'Perbandingan Error Instalasi',
        table: {
          headers: ['Error', 'Penyebab', 'Solusi'],
          rows: [
            ['App not installed', 'File rusak', 'Download ulang'],
            ['Parse error', 'Android lama', 'Update OS'],
            ['Install blocked', 'Permission', 'Enable unknown sources'],
          ],
        },
      },
      {
        title: 'Cara Memperbaiki Gagal Instal',
        conclusion: 'izin + file baru adalah kunci.',
        list: [
          'Aktifkan “Install unknown apps”',
          'Hapus APK lama jika ada',
          'Download ulang WA GB versi terbaru',
          'Restart perangkat sebelum instal',
        ],
      },
      {
        title: 'Bagaimana Mencegah Error Ini?',
        conclusion: 'sumber file sangat menentukan.',
        list: ['Gunakan versi stabil', 'Hindari file tidak jelas', 'Pastikan Android 5.0+'],
      },
    ],
    faq: [
      {
        q: 'Kenapa muncul parse error?',
        a: 'Karena versi Android tidak cocok.',
      },
      {
        q: 'Apakah WA GB bisa dipasang di semua HP?',
        a: 'Tidak, butuh kompatibilitas minimum.',
      },
    ],
  },
  {
    slug: 'send-message',
    path: '/wa-gb-tidak-bisa-mengirim-pesan/',
    cardTitle: 'WA GB Tidak Bisa Mengirim Pesan',
    listTitle: 'WA GB Tidak Bisa Mengirim Pesan? Kenapa Chat Saya Tidak Terkirim',
    description:
      'Solusi lengkap jika WA GB tidak bisa mengirim pesan, chat hanya centang satu, atau gagal terkirim. Cek penyebab dan cara memperbaikinya dengan mudah.',
    date: '6 Jul 2026',
    image: blogImages.sendMessage,
    imageAlt: 'WA GB Tidak Bisa Mengirim Pesan',
    sections: [
      {
        title: 'WA GB Tidak Bisa Mengirim Pesan? Kenapa Chat Saya Tidak Terkirim?',
        paragraphs: [
          'Kalau pesan di WA GB tidak terkirim, biasanya bukan error besar. Dalam banyak kasus, ini terjadi karena jaringan tidak stabil, server delay, atau aplikasi tidak sinkron dengan sistem WhatsApp. Solusi tercepat adalah mengganti jaringan, restart aplikasi, dan memastikan versi sudah terbaru.',
        ],
      },
      {
        title: 'Kenapa Pesan Saya Hanya Centang Satu?',
        conclusion: 'pesan belum sampai ke server.',
        paragraphsAfter: [
          'Ini adalah masalah paling umum. Artinya pesan masih di perangkat kamu dan belum terkirim ke sistem WhatsApp.',
        ],
      },
      {
        title: 'Kenapa Pesan Tiba-Tiba Gagal Dikirim?',
        conclusion: 'gangguan server atau koneksi adalah penyebab utama.',
        listIntro: 'Beberapa pengguna mengalami pesan stuck atau gagal kirim karena:',
        list: ['Sinyal lemah', 'Server WA GB delay', 'Mode hemat data aktif'],
      },
      {
        title: 'Kenapa Chat Bisa Normal Tapi Kadang Error?',
        conclusion: 'koneksi tidak stabil menyebabkan gangguan sementara.',
        paragraphsAfter: ['Kadang aplikasi terlihat normal, tapi pengiriman pesan gagal sesekali.'],
      },
      {
        title: 'Perbandingan Gejala Pengiriman Pesan',
        table: {
          headers: ['Gejala', 'Penyebab', 'Tingkat Masalah', 'Solusi'],
          rows: [
            ['Centang 1', 'Jaringan', 'Ringan', 'Ganti koneksi'],
            ['Pesan delay', 'Server', 'Sedang', 'Restart app'],
            ['Tidak terkirim', 'Cache', 'Sedang', 'Clear data'],
          ],
        },
      },
      {
        title: 'Cara Mengembalikan Pengiriman Normal',
        conclusion: 'reset koneksi biasanya langsung memperbaiki.',
        list: [
          'Aktifkan mode pesawat 10 detik',
          'Ganti WiFi atau data seluler',
          'Restart WA GB',
          'Update ke versi terbaru',
        ],
      },
      {
        title: 'Bagaimana Supaya Tidak Terjadi Lagi?',
        conclusion: 'stabilitas jaringan lebih penting dari aplikasi.',
        list: [
          'Gunakan koneksi stabil',
          'Jangan jalankan banyak mod bersamaan',
          'Update aplikasi secara berkala',
        ],
      },
    ],
    faq: [
      {
        q: 'Kenapa pesan saya tidak terkirim tapi internet normal?',
        a: 'Karena server delay atau cache error.',
      },
      {
        q: 'Apakah ini bug permanen?',
        a: 'Tidak, biasanya sementara.',
      },
    ],
  },
  {
    slug: 'login',
    path: '/wa-gb-tidak-bisa-login/',
    cardTitle: 'WA GB Tidak Bisa Login',
    listTitle: 'Cara Mengatasi WA GB Tidak Bisa Login – Kenapa Saya Tidak Bisa Masuk WA GB?',
    description:
      'Panduan lengkap mengatasi WA GB tidak bisa login, gagal verifikasi, dan masalah masuk akun. Temukan penyebab utama dan solusi terbaru agar WA GB kembali normal.',
    date: '6 Jul 2026',
    image: blogImages.login,
    imageAlt: 'Cara Mengatasi WA GB Tidak Bisa Login',
    sections: [
      {
        title: 'Cara Mengatasi WA GB Tidak Bisa Login – Kenapa Saya Tidak Bisa Masuk WA GB?',
        paragraphs: [
          'Kalau WA GB kamu tiba-tiba tidak bisa login, biasanya bukan karena satu hal saja. Dalam kebanyakan kasus, ini terjadi karena versi aplikasi sudah tidak cocok, sistem keamanan WhatsApp mendeteksi aktivitas tidak biasa, atau koneksi verifikasi gagal. Solusi paling efektif adalah update ke versi terbaru, membersihkan data aplikasi, dan mencoba login ulang dengan jaringan stabil.',
        ],
      },
      {
        title: 'Kenapa WA GB Tiba-Tiba Tidak Bisa Login?',
        paragraphs: [
          'Banyak pengguna baru bingung kenapa aplikasi yang sebelumnya normal tiba-tiba tidak bisa masuk. Masalah ini biasanya tidak muncul tanpa alasan, tetapi karena sistem WhatsApp melakukan perubahan atau ada gangguan di sisi aplikasi mod.',
        ],
        conclusion: 'login gagal biasanya tanda versi atau sistem sudah tidak sinkron.',
        paragraphsAfter: [
          'Ketika server WhatsApp memperbarui sistem keamanan, beberapa versi WA GB lama langsung kehilangan akses login.',
        ],
      },
      {
        title: 'Kenapa Verifikasi Nomor Selalu Gagal?',
        conclusion: 'sistem OTP sering gagal karena dianggap aktivitas tidak normal.',
        listIntro: 'Banyak kasus menunjukkan bahwa kode verifikasi tidak masuk atau selalu gagal dimasukkan. Ini biasanya terjadi karena:',
        list: [
          'Nomor terlalu sering login di perangkat berbeda',
          'Jaringan tidak stabil saat menerima OTP',
          'Server sementara membatasi request',
        ],
      },
      {
        title: 'Kenapa Setelah Update Justru Tidak Bisa Masuk?',
        conclusion: 'update yang tidak bersih bisa menyebabkan konflik data lama.',
        paragraphsAfter: [
          'Kadang pengguna langsung update tanpa menghapus cache lama. Ini menyebabkan sistem membaca dua versi berbeda dalam satu perangkat.',
        ],
      },
      {
        title: 'Perbandingan Penyebab Login Gagal',
        table: {
          headers: ['Situasi', 'Penyebab Utama', 'Dampak', 'Solusi'],
          rows: [
            ['Tidak bisa OTP', 'Server delay', 'Tidak login', 'Ganti jaringan'],
            ['Loading terus', 'Cache rusak', 'Gagal masuk', 'Clear data'],
            ['Login ditolak', 'Versi lama', 'Block sementara', 'Update APK'],
          ],
        },
      },
      {
        title: 'Cara yang Benar untuk Memulihkan Login',
        conclusion: 'kombinasi update + reset data paling efektif.',
        listIntro: 'Langkah yang biasanya berhasil:',
        list: [
          'Hapus cache aplikasi',
          'Pastikan versi WA GB terbaru',
          'Gunakan jaringan berbeda (WiFi/data)',
          'Login ulang dengan nomor yang sama',
        ],
      },
      {
        title: 'Bagaimana Mencegah Masalah Ini Terjadi Lagi?',
        conclusion: 'stabilitas tergantung pada versi dan cara penggunaan.',
        list: [
          'Jangan terlalu sering ganti versi',
          'Selalu gunakan APK dari versi stabil',
          'Hindari login di banyak perangkat',
        ],
      },
    ],
    faq: [
      {
        q: 'Kenapa WA GB saya tiba-tiba logout?',
        a: 'Karena sistem mendeteksi perubahan atau update server.',
      },
      {
        q: 'Apakah data saya hilang saat login ulang?',
        a: 'Tidak selalu, tergantung backup.',
      },
      {
        q: 'Apakah ini tanda akun diblokir?',
        a: 'Bisa jadi sementara, bukan permanen.',
      },
    ],
  },
];

export const latestArticles = {
  title: 'Artikel Terbaru',
  intro: 'Berikut beberapa panduan terbaru yang mungkin membantu kamu:',
};

export function getPostBySlug(slug) {
  return blogPosts.find((post) => post.slug === slug) || null;
}

export function getRelatedPosts(currentSlug) {
  return blogPosts.filter((post) => post.slug !== currentSlug);
}
